import { IRadiolabelsHistoryFilters } from "@services/http/repositories/Radiolabels.repository";

export enum ActionRadiolabelsHistoryTypes {
  ADD_FLITERS = "ADD_FLITERSERS",
  ADD_RADIOLABELS_HISTORY = "ADD_RADIOLABELS_HISTORYHISTORY",
  DELETE_RADIOLABELS_HISTORY = "DELETE_RADIOLABELS_HISTORY",
  REMOVE_FLITER = "REMOVE_FLITER",
  EDIT_FILTERS = "EDIT_FILTERS",
}

export interface ActionRadiolabelsHistoryBase {
  type: ActionRadiolabelsHistoryTypes;
  payload?: any;
}

export interface ActionRadiolabelsHistoryAddFilters
  extends ActionRadiolabelsHistoryBase {
  payload: IRadiolabelsHistoryFilters;
}
export interface ActionRadiolabelsHistoryDeleteFilters
  extends ActionRadiolabelsHistoryBase {}

export interface ActionRadiolabelsHistoryEditFilters
  extends ActionRadiolabelsHistoryBase {
  payload: IRadiolabelsHistoryFilters;
}

export interface ActionRemoveRadiolabelsHistory
  extends ActionRadiolabelsHistoryBase {
  payload: keyof IRadiolabelsHistoryFilters;
}
